import React from "react";
import * as styles from "./FollowUs.module.scss";
import clsx from "clsx";
import { Icon } from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react/macro";

interface FollowUsProps {
  className?: string;
}

const FollowUs: React.FC<React.PropsWithChildren<FollowUsProps>> = ({
  className
}) => {
  return (
    <div
      className={clsx(styles.followUs, className)}
      data-content-name="follow_social_media"
    >
      <span>
        <Trans>FOLLOW US</Trans>
      </span>
      <ul className={styles.socialList}>
        <li>
          <a
            title="Facebook"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/SilverseaCruises"
            data-content-piece="follow_facebook"
          >
            <Icon
              name="facebook"
              size="1.5x"
              padding={false}
              ariaHidden={true}
            />
          </a>
        </li>
        <li>
          <a
            title="Instagram"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/silverseacruises/"
            data-content-piece="follow_instagram"
          >
            <Icon
              name="instagram"
              size="1.5x"
              padding={false}
              ariaHidden={true}
            />
          </a>
        </li>
        <li>
          <a
            title="Twitter"
            target="_blank"
            rel="noopener noreferrer"
            href="https://twitter.com/Silversea"
            data-content-piece="follow_twitter"
          >
            <Icon
              name="twitter"
              size="1.5x"
              padding={false}
              ariaHidden={true}
            />
          </a>
        </li>
        <li>
          <a
            title="YouTube"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.youtube.com/user/SilverseaOfficial"
            data-content-piece="follow_youtube"
          >
            <Icon
              name="you-tube"
              size="1.5x"
              padding={false}
              ariaHidden={true}
            />
          </a>
        </li>
        <li>
          <a
            title="Pinterest"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.pinterest.com/silverseacruise/"
            data-content-piece="follow_pintrest"
          >
            <Icon
              name="pinterest"
              size="1.5x"
              padding={false}
              ariaHidden={true}
            />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default FollowUs;
